import React from "react";
import { Link } from "react-router-dom";

type Variant = "primary" | "danger" | "outline" | "ghost" | "neutral";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: "sm" | "md" | "lg";
  to?: string;
  as?: "button" | "link";
  className?: string;
}

const base =
  "inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";

const variants: Record<Variant, string> = {
  primary: "bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-500",
  danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
  outline:
    "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-gray-300",
  ghost: "bg-transparent text-gray-700 hover:bg-gray-100 focus:ring-gray-200",
  neutral: "bg-gray-600 text-white hover:bg-gray-700 focus:ring-gray-500",
};

const sizes: Record<string, string> = {
  sm: "px-2 py-1 text-sm",
  md: "px-3 py-2 text-sm md:text-base",
  lg: "px-4 py-2 text-base md:px-5 md:py-3",
};

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  to,
  as = "button",
  className = "",
  children,
  ...rest
}) => {
  const cls = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  if (as === "link" && to) {
    return (
      <Link to={to} className={cls} {...(rest as any)}>
        {children}
      </Link>
    );
  }

  return (
    <button className={cls} {...(rest as any)}>
      {children}
    </button>
  );
};

export default Button;
